import React from 'react';
import styled from '@emotion/native';
import { BaseText } from '@/shared/components/StyledText';
import { accent, sand, white } from '@/shared/styles/colors';
import { ProgressBar } from 'react-native-paper';

interface ProgressProps {
  progress: number;
  totalSteps: number;
}

const InstantStylingModalProgress: React.FC<ProgressProps> = ({
  progress,
  totalSteps,
}) => {
  return (
    <Container>
      <ProgressBarContainer>
        <StyledProgressBar progress={progress / totalSteps} color={accent} />
      </ProgressBarContainer>
      <StepLabel>
        {progress}/{totalSteps} completed
      </StepLabel>
    </Container>
  );
};

const Container = styled.View({
  backgroundColor: sand,
  justifyContent: 'center',
  alignItems: 'center',
  paddingTop: 16,
  paddingBottom: 24,
});

const ProgressBarContainer = styled.View({
  flexDirection: 'row',
});

const StyledProgressBar = styled(ProgressBar)({
  width: 300,
  height: 12,
  borderRadius: 10,
  backgroundColor: white,
  marginBottom: 8,
});

const StepLabel = styled(BaseText)({
  fontSize: 10,
  marginLeft: 8,
});

export default InstantStylingModalProgress;
